import {WebPage} from "../types";
import React, {ReactElement} from "react";
import {SectionView, SectionViewMode} from "./SectionView";
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
import 'swiper/css/effect-cube';
import {SiteTemplate} from "../page-components/types";
import {gray} from "../../shared/colors";
import {DIVIDER} from "../../shared/dimens";

export function Preview(props: { webPage: WebPage, template: SiteTemplate }): ReactElement {
  return <div
    style={{
      width: "100dvw",
      height: "100dvh",
      display: "flex",
      flexDirection: "column",
      overflowY: "scroll",
      position: "relative",
      background: gray,
    }}>
    <div style={{
      width: 1200,
      background: "white",
      margin: "auto",
      borderLeft: DIVIDER,
      borderRight: DIVIDER,
      display: "flex",
      flexDirection: "column"
    }}>
      {props.webPage.sections?.map((section, index) =>
        <SectionView
          mode={SectionViewMode.PREVIEW}
          webPage={props.webPage}
          template={props.template}
          sectionIndex={index}/>)}
    </div>
  </div>;
}